import Header from './components/Header';
import Hero from './components/Hero';
import Development from './components/Development';
import Location from './components/Location';
import ModernSpace from './components/ModernSpace';
import TradeIndustrial from './components/TradeIndustrial';
import Offices from './components/Offices';
import Availability from './components/Availability';
import Sustainability from './components/Sustainability';
import Showcase from './components/Showcase';
import Investment from './components/Investment';
import FutureGrowth from './components/FutureGrowth';
import Enquire from './components/Enquire';
import Footer from './components/Footer';
import { useEffect } from 'react';
import './App.css';
import './leaflet-custom.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';

function Home() {
  useEffect(() => {
    document.title = 'Valley Mills · Pudsey, Leeds';
  }, []);
  return (
    <div className="bg-[#f1ede5] text-[#0d281e] font-sans">
      <Header />
      <Hero />
      <Development />
      <Location />
      <ModernSpace />
      <TradeIndustrial />
      <Offices />
      <Availability />
      <Sustainability />
      <Showcase />
      <Investment />
      <FutureGrowth />
      <Enquire />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
